<template>
    <!-- 多选组件 -->
    <el-checkbox-group 
    v-model="value"
    :min="min"
    :max="max"
    :size="size"
    :disabled="disabled"
    :text-color="textColor" 
    :fill="fill"
    @change="change"
    >
        <template v-for="checkbox in checkboxList">
            <!-- 普通类型 -->
            <el-checkbox 
            v-if="!checkbox.btn" 
            :label="checkbox.label" 
            :key="checkbox.label" 
            :disabled="checkbox.disabled"
            :size="checkbox.size"
            :border="checkbox.border"
            :checked="checkbox.checked"
            >
                <slot :item="checkbox">{{checkbox.text}}</slot>
            </el-checkbox>
            <!-- 按钮类型 -->
            <el-checkbox-button 
            v-else
            :label="checkbox.label" 
            :key="checkbox.label" 
            :disabled="checkbox.disabled"
            :checked="checkbox.checked"
            >
                <slot :item="checkbox">{{checkbox.text}}</slot>
            </el-checkbox-button>
        </template>
    </el-checkbox-group> 
</template>
<script>
export default {
    name:"VelCheckbox",
    props:{
        initValue:Array,
        min:Number,
        max:Number,
        size:String,
        isDisable:Boolean,
        textColor:String,
        fill:String,
        checkboxList:{
            type:Array,
            required:true,
        }
    },
    data() {
        return {
            value:[],
            disabled:false,
        };
    },
    created() {
        // this.getValue()
        this.initDataFn()
    },
    watch: {
        initValue:{
            handler(newval){
                if(!newval) return 
                this.value = newval
            },
            deep:true,
            immediate:true
        }
    },
    methods: {
        initDataFn(){
            this.isDisable ? this.disabled = true : this.disabled
        },
        getValue(){
            this.initValue ? this.value = this.initValue : 
            this.value.push(this.checkboxList[0].label)
        },
        change(val){
            this.$emit('change',val)
        }
    }
}
</script>